<template>
    <div class="chat-button-full-width__wrapper">
        <button class="chat-button-full-width" v-if="isTrapButtonVisible()"
                @click="clickTrapButton()"
                :style="{'background-color': getPlayerColor(playerId), 'color': getButtonTextColor(getPlayerColor(playerId))}">
            {{ $t('button.trap_triggered') }}
        </button>

        <button class="chat-button-full-width" v-if="isExplanationButtonVisible()"
                @click="clickExplanationButton()"
                :style="{'background-color': getPlayerColor(playerId), 'color': getButtonTextColor(getPlayerColor(playerId))}">
            {{ $t('button.explanation_is_over') }}
        </button>

        <button class="chat-button-full-width" v-if="isCommandVersionVisible()"
                @click="clickCommandVersionButton()"
                :style="{'background-color': getPlayerColor(playerId), 'color': getButtonTextColor(getPlayerColor(playerId))}">
            {{ $t('button.command_version') }}
        </button>

        <div v-if="isAnswersButtonsVisible()" class="chat-buttons-wrapper">
            <button class="chat-button"
                    :disabled="!isAnswersActive()"
                    @click="clickAnswerButton(TYPE_CORRECT)"
                    :style="{'background-color': getPlayerColor(playerId), 'color': getButtonTextColor(getPlayerColor(playerId))}">
                {{ $t('button.correct') }}
            </button>
            <button class="chat-button"
                    :disabled="!isAnswersActive()"
                    @click="clickAnswerButton(TYPE_WRONG)"
                    :style="{'background-color': getPlayerColor(playerId), 'color': getButtonTextColor(getPlayerColor(playerId))}">
                {{ $t('button.incorrect') }}
            </button>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
import {Tool} from "../../../helpers/Tool";
import EventApi from "../../../api/EventsApi";

const TYPE_REACTION_UNLIKE = 2;

const TYPE_CORRECT = 'answer_correct';
const TYPE_WRONG = 'answer_wrong';

/**
 * Кастомные кнопки для игры "5 ловушек"
 */
export default {
    computed: {
        players: () => store.getters.getPlayers,
        playerId: () => store.getters.getPlayerId,
        gameState: () => store.getters.getGameState,
    },

    data() {
        return {
            TYPE_CORRECT: TYPE_CORRECT,
            TYPE_WRONG: TYPE_WRONG,
        }
    },

    methods: {
        /**
         * Видимость кнопки "Ловушка сработала"
         */
        isTrapButtonVisible()
        {
            let trapButton = this.gameState.zones.chat.buttons.five_traps.trap;

            if (!trapButton) {
                return false;
            }

            return trapButton.enabled && trapButton.observer_id === this.playerId;
        },

        getButtonTextColor(color)
        {
            if (!color) {
                return '#fff';
            }
            const isDark = Tool.isDark(color);
            return isDark ? '#fff' : '#000';
        },

        /**
         * Нажатие на кнопку "Ловушка сработала"
         */
        clickTrapButton()
        {
            EventApi.triggerEvent(EventApi.EVENT_SEND_MESSAGE, {
                type: 'reaction',
                data: {
                    type: TYPE_REACTION_UNLIKE,
                }
            });
        },

        /**
         * Видимость кнопки "Закончил объяснять"
         */
        isExplanationButtonVisible()
        {
            let explanationButton = this.gameState.zones.chat.buttons.five_traps.explanation;

            if (!explanationButton) {
                return false;
            }

            return explanationButton.enabled && explanationButton.master_id === this.playerId;
        },

        /**
         * Нажатие на кнопку "Закончил объяснять"
         */
        clickExplanationButton()
        {
            this.sendMessage('explanation');
        },

        /**
         * Видимлсть кнопки "версия команды"
         */
        isCommandVersionVisible()
        {
            let commandVersionButton = this.gameState.zones.chat.buttons.five_traps.command_version;

            if (!commandVersionButton) {
                return false;
            }

            return commandVersionButton.enabled && commandVersionButton.visible_for.indexOf(this.playerId) !== -1;
        },

        /**
         * Нажатие на копку "Версия команды"
         */
        clickCommandVersionButton()
        {
            this.sendMessage('command_version');
        },

        /**
         * Видимость кнопок "Верно-неверно"
         */
        isAnswersButtonsVisible()
        {
            let answersButtons = this.gameState.zones.chat.buttons.five_traps.answers;

            if (!answersButtons) {
                return false;
            }

            return answersButtons.enabled && answersButtons.observer_id === this.playerId;
        },

        /**
         * Активность кнопок "Верно-неверно"
         */
        isAnswersActive()
        {
            let answersButtons = this.gameState.zones.chat.buttons.five_traps.answers;

            if (!answersButtons) {
                return false;
            }

            return answersButtons.active;
        },

        /**
         * Нажатие на вариант ответа
         */
        clickAnswerButton(type)
        {
            this.sendMessage(type);
        },

        /**
         * Отправить сообщение
         * @param type
         */
        sendMessage(type)
        {
            EventApi.triggerEvent(EventApi.EVENT_SEND_MESSAGE, {
                type: 'customButton',
                data: {
                    zone: 'chat',
                    type: type,
                }
            });
        },

        /**
         * Цвет игрока по id
         * @param playerId
         * @return {null|*}
         */
        getPlayerColor(playerId)
        {
            return this.$parent.getPlayerColor(playerId);
        },
    }
}
</script>

<style scoped>

</style>
